var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"item",class:{active: _vm.active},on:{"click":_vm.select}},[_vm._v("\n\t"+_vm._s(_vm.label)+"\n\t"),(_vm.active)?_c('span',{staticClass:"icon",domProps:{"innerHTML":_vm._s(require('@/assets/icons/check.svg'))}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }